import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CarouselComponent } from '../../../../modules/carousel/carousel.component';
import { CarouselTile } from '../../../../modules/carousel/carousel.model';

@Component({
  selector: 'app-kontakt-carousel',
  imports: [
    CarouselComponent
  ],
  templateUrl: './kontakt-carousel.component.html',
  styleUrls: ['./kontakt-carousel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class KontaktCarouselComponent {

  public tiles: CarouselTile[] = [
    // {
    //   img: {
    //     src: 'assets/img/md/etc1.webp',
    //     width: 1120,
    //     height: 840,
    //     alt: 'YSTM Touren-Segler unterwegs',
    //     srcset: [
    //       'assets/img/xs/etc1.webp 688w',
    //       'assets/img/sm/etc1.webp 912w',
    //       'assets/img/md/etc1.webp 1120w',
    //       'assets/img/lg/etc1.webp 1360w',
    //       'assets/img/xl/etc1.webp 2320w',
    //     ],
    //     sizes: ['90vw'],
    //     priority: true,
    //   }
    // },
    {
      img: {
        src: 'assets/img/reusen1.jpg',
        // width: 5400, 
        // height: 3584,
        alt: 'Boote hinter Reusen',
        // breakpoints: [300, 1020, 1410, 1710, 1970, 2190, 2400, 2590, 2760, 2930, 3090, 3240, 3380, 3520, 3648],
        sizes: ['90vw'],
        priority: true,
      }
    },
    {
      img: {
        src: 'assets/img/dn6.jpg',
        // width: 5400,
        // height: 3131,
        alt: 'Fliegende DN-Schlitten',
        // breakpoints: [300, 1020, 1410, 1710, 1970, 2190, 2400, 2590, 2760, 2930, 3090, 3240, 3380, 3520, 3648],
        sizes: ['90vw'],
        loading: 'lazy',
      }
    },
    {
      img: {
        src: 'assets/img/pboot8.jpg',
        // width: 5400,  
        // height: 3038,
        alt: '15qm-Jollenkreuzer-Event im YSTM',
        // breakpoints: [300, 1020, 1410, 1710, 1970, 2190, 2400, 2590, 2760, 2930, 3090, 3240, 3380, 3520, 3648],
        sizes: ['90vw'],
        loading: 'lazy',
      }
    },
    {
      img: {
        src: 'assets/img/regattafeld1.jpg',
        // width: 5400,
        // height: 1180,
        alt: '15qm-Jollenkreuzer Regatta-Feld',
        // breakpoints: [300, 1020, 1410, 1710, 1970, 2190, 2400, 2590, 2760, 2930, 3090, 3240, 3380, 3520, 3648],
        sizes: ['90vw'],
        loading: 'lazy',
      }
    },
    // {
    //   img: {
    //     src: 'assets/img/md/steg1.webp',
    //     width: 1120,
    //     height: 629,
    //     alt: 'YSTM Steg',
    //     srcset: [
    //       'assets/img/xs/steg1.webp 688w',
    //       'assets/img/sm/steg1.webp 912w',
    //       'assets/img/md/steg1.webp 1120w',
    //       'assets/img/lg/steg1.webp 1360w',
    //       'assets/img/xl/steg1.webp 2320w',
    //     ],
    //     sizes: ['90vw'],
    //     loading: 'lazy',
    //   }
    // },
    // {
    //   img: {
    //     src: 'assets/img/md/etc2.webp',
    //     width: 1120,
    //     height: 840,
    //     alt: 'YSTM Touren-Segler unterwegs',
    //     srcset: [
    //       'assets/img/xs/etc2.webp 688w',
    //       'assets/img/sm/etc2.webp 912w',
    //       'assets/img/md/etc2.webp 1120w',
    //       'assets/img/lg/etc2.webp 1360w',
    //       'assets/img/xl/etc2.webp 2320w',
    //     ],
    //     sizes: ['90vw'],
    //     loading: 'lazy',
    //   }
    // },
    {
      img: {
        src: 'assets/img/heinstude10.jpg',
        // width: 4050, 
        // height: 5400,
        alt: 'Klassisches Rigg des YSTM-Auswanderers Hein-Stude',
        // breakpoints: [300, 1020, 1410, 1710, 1970, 2190, 2400, 2590, 2760, 2930, 3090, 3240, 3380, 3520, 3648],
        sizes: ['90vw'],
        loading: 'lazy',
      }
    },
    {
      img: {
        src: 'assets/img/heinstude5.jpg',
        // width: 3648, 
        // height: 2056,
        alt: 'Abendstimmung im YSTM',
        // breakpoints: [300, 1020, 1410, 1710, 1970, 2190, 2400, 2590, 2760, 2930, 3090, 3240, 3380, 3520, 3648],
        sizes: ['90vw'],
        loading: 'lazy',
      }
    },
  ];

  // public tiles: YsCarouselTile[] = [
  //   {styleClass: 'carKontakt1'},
  //   {styleClass: 'carKontakt2'},
  //   {styleClass: 'carKontakt3'},
  // ]

}
